<template>
  <div class="auth-employer-login">
    <form class="auth-employer-login__main"
          @submit.prevent="onSubmit">
      <BasePreloader v-if="pending"/>
      <h1 class="auth-employer-login__title">{{ $tAuthEmployerRegister('title') }}</h1>
      <div class="auth-employer-login__inputs">
        <BaseInput v-model="inputs.email.value"
                   :error="inputs.email.error"
                   :label="$tAuthEmployerRegister('input_email')"
                   :sub="$tAuthEmployerRegister('input_email_sub')"
                   type="email"
                   autocomplete="employer-email-register"
                   class="auth-employer-login__input"
                   @input="submittedFormWithNoAgree = false"/>
        <BaseInput v-model="inputs.password.value"
                   :error="inputs.password.error"
                   :label="$tAuthEmployerRegister('input_password')"
                   type="password"
                   :placeholder="passwordPlaceholder"
                   autocomplete="employer-password-register"
                   class="auth-employer-login__input"
                   @input="submittedFormWithNoAgree = false"
                   @focus="inputs.password.focus = true"
                   @blur="inputs.password.focus = false"/>
        <BaseInput v-model="inputs.re_password.value"
                   :error="inputs.re_password.error"
                   :label="$tAuthEmployerRegister('input_re_password')"
                   type="password"
                   :placeholder="confirmPasswordPlaceholder"
                   autocomplete="employer-password-register"
                   class="auth-employer-login__input"
                   @input="submittedFormWithNoAgree = false"
                   @focus="inputs.re_password.focus = true"
                   @blur="inputs.re_password.focus = false"/>
      </div>
      <div class="auth-employer-login__agree-wrap">
        <BaseCheckbox v-model="agree"
                      class="auth-employer-login__agree"
                      @input="onAgreeInput">
          <div slot="label"
               class="checkbox__text">
            {{ $tAuthEmployerRegister('i_agree') }}
            <router-link-modified target="_blank" :to="{name: 'terms-of-use'}">
              {{ $tAuthEmployerRegister('i_agree_documents') }}
            </router-link-modified>
          </div>
        </BaseCheckbox>
      </div>
      <BaseAlert :value="overallErrorsMix"
                 class="auth-employer-login__error  _warning"/>
      <button
        type="submit"
        :disabled="disabledRegisterButton"
        class="auth-employer-login__btn  base-btn  base-btn--blue"
      >
        {{ $tAuthEmployerRegister('btn_register') }}
      </button>
    </form>

    <div class="auth-employer-login__footer">
      <div class="auth-employer-login__footer-main">
        <div class="auth-employer-login__footer-title">
          {{ $tAuthEmployerRegister('footer_login_title') }}
        </div>
        <router-link-modified :to="{name: 'auth-employer', query: {...$route.query}}"
                              class="auth-employer-login__footer-btn  base-btn  base-btn--green">
          {{ $tAuthEmployerRegister('footer_login_btn') }}
        </router-link-modified>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import formMixins from '@/mixins/formMixins'
  import {EMPLOYER} from '@/constants/usersTypes'

  export default {
    name: 'AuthEmployerRegister',
    mixins: [formMixins],
    data() {
      return {
        pending: false,

        agree: false,

        inputs: {
          email: {
            value: null
          },
          password: {
            value: null,
            focus: false,
          },
          re_password: {
            value: null,
            focus: false,
          },
          user_type: {
            value: EMPLOYER
          }
        },

        submittedFormWithNoAgree: false,
      }
    },
    computed: {
      disabledRegisterButton() {
        return !Object.values(this.inputs).every(i => i.value);
      },
      passwordPlaceholder() {
        return this.inputs.password.focus ? '' : this.$tAuthEmployerRegister('The field must contain at least');
      },
      confirmPasswordPlaceholder() {
        return this.inputs.re_password.focus ? '' : this.$tAuthEmployerRegister('The field must contain at least');
      },
    },
    referralCode() {
      return this.$route.query.referal_code || getReferralFromLocalstorage()
    },
    methods: {
      ...mapActions('user', [
        'registerEmployer'
      ]),
      onAgreeInput() {
        if (this.agree) {
          this.removeNotAgreedErr();
          if (this.submittedFormWithNoAgree) this.onSubmit();
        }
      },
      onSubmit() {
        if (!this.agree) {
          this.onSubmitWithNoAgree();
          return;
        }

        this.pending = true

        this.resetErrorsMix(this.inputs)
        let sendData = this.createSendDataMix(this.inputs)

        sendData = Object.assign({}, this.$route.query, sendData)

        this.registerEmployer({sendData})
          .then(() => {
            this.afterLogin()
          })
          .catch(e => {
            this.errorHandlerMix(e, this.inputs)
          })
          .finally(() => {
            this.pending = false
          })
      },
      onSubmitWithNoAgree() {
        this.submittedFormWithNoAgree = true;
        this.addNotAgreedErr();
      },
      addNotAgreedErr() {
        if (!this.overallErrorsMix) this.overallErrorsMix = [];
        else if (typeof this.overallErrorsMix === 'string') this.overallErrorsMix = [this.overallErrorsMix];

        const err = this.$tAuthEmployerRegister('not_agreed_err');
        this.overallErrorsMix.push(err);
      },
      removeNotAgreedErr() {
        if (!Array.isArray(this.overallErrorsMix)) return;
        const err = this.$tAuthEmployerRegister('not_agreed_err');
        const idx = this.overallErrorsMix.findIndex(e => e === err);
        this.overallErrorsMix.splice(idx, 1);
      },
      afterLogin() {
        if (this.$route.query.redirect) {
          this.$router.push({path: this.$route.query.redirect})
        } else {
          this.$router.push({name: 'account-vacancies'})
            .catch(() => ({}))
        }
      }
    },
    created() {
      if (this.referralCode) {
        setReferralToLocalstorage(this.referralCode)
      }
    }
  }

  function setReferralToLocalstorage(code) {
    window.localStorage.setItem('referralCode', code)
  }

  function getReferralFromLocalstorage() {
    return window.localStorage.getItem('referralCode')
  }
</script>

<style lang="less">

</style>
